import LogosDisplay from './LogosDisplay';

export default LogosDisplay;
